/**
 * NotificationNavigationBridge — most Service Worker → SPA routing.
 *
 * Po kliknutí na push notifikaci service worker zaostří existující okno appky a
 * pošle mu `{ type: "notification-navigate", url }`. Tady zprávu přeložíme na
 * **client-side** navigaci (react-router), takže nedojde k full reloadu → žádná
 * bílá stránka a u E2EE chatu zůstanou klíče v paměti.
 *
 * Když appka běžela už na cílové routě, nic se nerozbije; když ji SW otevřel nově
 * (openWindow), URL je správná už z načtení a tato zpráva ani nepřijde.
 *
 * Mountuje se uvnitř <BrowserRouter> (potřebuje `useNavigate`).
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function NotificationNavigationBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

    const onMessage = (e: MessageEvent): void => {
      const data = e.data as { type?: string; url?: string } | null;
      if (data?.type !== "notification-navigate" || !data.url) return;
      try {
        const u = new URL(data.url, window.location.origin);
        // Bezpečnost: navigujeme jen v rámci vlastního originu.
        if (u.origin !== window.location.origin) return;
        navigate(u.pathname + u.search + u.hash);
      } catch {
        /* neplatná URL — ignoruj */
      }
    };

    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [navigate]);

  return null;
}
